/** Default path for the APA Parts colour logo (resolved via the resource base URL). */
export const DEFAULT_LOGO_SRC = "images/logo-v20260825.png";
/** Default path for the APA Parts logo on DARK backgrounds (footer): the OFFICIAL
 *  white wordmark (white "APA · turbo · PARTS" + green emblem), matching the black
 *  header wordmark. The colour `logo.svg` is near-black (#121212) and was invisible
 *  on the dark footer. */
export const DEFAULT_LOGO_WHITE_SRC = "images/logo-white-v20260825.png";
/** Default alt text for the APA Parts logo. */
export const DEFAULT_LOGO_ALT = "APA Parts";
